import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState, useCallback } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddQNAModal from "../components/AddQNAModal";
import ReactQuill from "react-quill";

const ServiceCenterFaq = ({ title, data, setData }) => {
  // If data.faqs is an array (legacy), migrate it to object. Otherwise use it as object.
  const faqData = Array.isArray(data?.faqs) 
    ? { title: "", description: "", faqs: data.faqs } 
    : (data?.faqs || { title: "", description: "", faqs: [] });
  
  const faqsList = Array.isArray(faqData.faqs) ? faqData.faqs : [];

  const [showModal, setShowModal] = useState(false);
  const [selectedFaq, setSelectedFaq] = useState(null);

  const handleModal = useCallback((show = false, selectedObj = null) => {
    setShowModal(show);
    setSelectedFaq(selectedObj);
  }, []);

  const handleChange = useCallback((name) => (value) => {
    setData((prev) => {
      const prevFaqs = Array.isArray(prev.faqs) 
        ? { title: "", description: "", faqs: prev.faqs } 
        : (prev.faqs || {});

      return {
        ...prev,
        faqs: {
          ...prevFaqs,
          [name]: value || ""
        }
      };
    });
  }, [setData]);

  const handleQNA = useCallback((faqObj) => {
    let { index, ...rest } = faqObj;

    setData((prev) => {
      const prevFaqs = Array.isArray(prev.faqs) 
        ? { title: "", description: "", faqs: prev.faqs } 
        : (prev.faqs || { title: "", description: "", faqs: [] });
      
      const currentList = Array.isArray(prevFaqs.faqs) ? prevFaqs.faqs : [];

      let updatedList;
      if (index !== undefined) {
        updatedList = currentList.map((item, i) => i === index ? rest : item);
      } else {
        updatedList = [...currentList, rest];
      }

      return {
        ...prev,
        faqs: { ...prevFaqs, faqs: updatedList }
      };
    });
  }, [setData]);

  const handleDelete = useCallback((index) => {
    setData((prev) => {
      const prevFaqs = Array.isArray(prev.faqs) 
        ? { title: "", description: "", faqs: prev.faqs } 
        : (prev.faqs || { title: "", description: "", faqs: [] });
      
      const currentList = Array.isArray(prevFaqs.faqs) ? prevFaqs.faqs : [];

      return {
        ...prev,
        faqs: {
          ...prevFaqs,
          faqs: currentList.filter((_, i) => i !== index)
        }
      };
    });
  }, [setData]);

  return (
    <Box mt={3}>
      <Typography fontWeight="600" mb={2}>
        {title}
      </Typography>

      <div className="form_comp">
        <label>FAQ Title</label>
        <ReactQuill
          value={faqData.title || ""}
          onChange={handleChange("title")}
        />
      </div>

      <div className="form_comp mt15">
        <label>FAQ Description</label>
        <ReactQuill
          value={faqData.description || ""}
          onChange={handleChange("description")}
        />
      </div>

      <Button
        variant="contained"
        sx={{ mb: 3, mt: 2 }}
        onClick={() => handleModal(true)}
      >
        + Add FAQ
      </Button>

      {/* 🔥 TABLE */}
      {faqsList.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><b>Question</b></TableCell>
                <TableCell><b>Answer</b></TableCell>
                <TableCell><b>Edit</b></TableCell>
                <TableCell><b>Delete</b></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {faqsList.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Typography
                      dangerouslySetInnerHTML={{ __html: item.question }}
                    />
                  </TableCell>

                  <TableCell>
                    <Typography
                      dangerouslySetInnerHTML={{ __html: item.answer }}
                    />
                  </TableCell>

                  <TableCell onClick={() => handleModal(true, { ...item, index })}>
                    <EditIcon sx={{ cursor: "pointer" }} />
                  </TableCell>

                  <TableCell onClick={() => handleDelete(index)}>
                    <DeleteIcon sx={{ cursor: "pointer", color: "gray" }} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <AddQNAModal
        open={showModal}
        handleClose={() => handleModal(false)}
        selectedQNA={selectedFaq}
        handleQNA={handleQNA}
      />
    </Box>
  );
};

export default ServiceCenterFaq;